/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SnippetCreateVisibility = typeof SnippetCreateVisibility[keyof typeof SnippetCreateVisibility];


export const SnippetCreateVisibility = {
  private: 'private',
  shared: 'shared',
} as const;
